import gql from 'graphql-tag';

const SIM_AUDIT_LOGS = gql`
  query Query($simNumber: String!, $limit: Int, $skip: Int) {
    simAuditLogs(simNumber: $simNumber, limit: $limit, skip: $skip) {
      auditData
      type
      customer
      createdOn
      isInternalAudit
    }
  }
`;

export default SIM_AUDIT_LOGS;
